import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  Divider,
  Input,
  IconButton,
  InputLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import avatar from "assets/theme/components/avatar";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const AddBusiness_activitiesForm = ({ onClose, onSuccess, initialData }) => {
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    is_active: initialData?.is_active || 1,
    id: initialData?.id || null, // Add ID field
  });
  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name,
        is_active: initialData.is_active,
        id: initialData.id,
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.name)) newErrors.name = "يجب إدخال الاسم";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateForm()) return;

    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          // Handle avatar differently for existing vs new
          formPayload.append(key, value);
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/business-activities/update/${formData.id}`
        : BASE_URL + "/administrator/business-activities/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      is_active: 1,
    });
    setErrors({});
    onClose();
  };

  return (
    <Box
      sx={{
        p: 3,
        width: 600,
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography
          variant="h5"
          fontWeight="bold"
        // color={darkMode ? theme.palette.text.primary : "inherit"}
        >
          {formData.id ? "تعديل النشاط التجاري" : "إضافة نشاط تجاري جديد"}
        </Typography>
      </Box>
      {/* Main Form */}
      <Box container spacing={3}>
        {/* Left Column */}
        <Box display="flex" gap={2} sx={{ mb: 2 }}>
          <FormControl fullWidth error={!!errors.name} sx={{ mb: 2 }}>
            <TextField
              label="اسم النشاط التجاري *"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              InputLabelProps={{
                style: {
                  // color: darkMode ? theme.palette.text.primary : undefined,
                },
              }}
              InputProps={{
                style: {
                  // color: darkMode ? theme.palette.text.primary : undefined,
                  // background: darkMode ? theme.palette.background.paper : undefined,
                },
              }}
            />
          </FormControl>
          {/* حقل حالة النشاط */}
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="is_active-label">حالة النشاط *</InputLabel>
            <Select
              label="حالة النشاط *"
              name="is_active"
              value={formData.is_active}
              onChange={handleChange}
              displayEmpty
              sx={{
                height: "40px",
                // color: darkMode ? theme.palette.text.primary : undefined,
                // background: darkMode ? theme.palette.background.paper : undefined,
              }}
            >
              <MenuItem value="1">مفعل</MenuItem>
              <MenuItem value="0">غير مفعل</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2">* الحقول المطلوبة</Typography>
        <Box display="flex" gap={2}>
          <Button
            variant="outlined"
            color="text"
            onClick={handleCancel}
            sx={{ px: 4, color: "text.main", borderColor: "text.border" }}
          >
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important", bgcolor: "primary.dark", "&:hover": { bgcolor: "primary.main" } }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddBusiness_activitiesForm;
